const Checkmark = ({ size = 16, color = "#ffffff", width = 2, opacity = 1, className = "" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none"
    className={className}
    style={{ opacity: opacity, transition: 'opacity 0.15s ease' }}
  >
    <path
      d="M20 6L9 17L4 12"
      stroke={color}
      strokeWidth={width}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Checkmark;
